module.exports = __webpack_public_path__ + "static/media/nav_logo.3d70e15d.png";